module.exports = __webpack_public_path__ + "assets/img/00058.336b5cd0.png";